export default "__VITE_ASSET__DUvzbsuL__"